<div class="outer-container">
    <div class="inner-container">
        {{ (isFilterValid ? 'common.noResults' : filterInvalidInfo) | translate }}
    </div>
</div>
